'use client'

import clsx from 'clsx'

import { useDisplayCart } from 'modules/cart'
import { getTimeFromDate, parseDateToDDMMYYYY } from 'shared/utils/date'

import { useEditSaleOrderModals } from '../providers/EditSaleOrderModalsContext'

import EditSaleOrderReminderButtons from './EditSaleOrderReminderButtons'

import styles from './EditSaleOrderReminder.module.scss'

const EditSaleOrderReminder = ({
  pageType,
  onlyButtons = false,
  buttonsDirection = 'horizontal'
}: {
  pageType?: string
  onlyButtons?: boolean
  buttonsDirection?: 'horizontal' | 'vertical'
}) => {
  const cart = useDisplayCart()
  const { handleCancelEditOrder, handleSubmitEditOrder, startOrder } =
    useEditSaleOrderModals()

  return cart && cart.editMode ? (
    startOrder ? (
      <>
        {onlyButtons ? (
          <EditSaleOrderReminderButtons
            handleCancelEditOrder={handleCancelEditOrder}
            handleSubmitEditOrder={handleSubmitEditOrder}
            direction={buttonsDirection}
          />
        ) : (
          <div
            className={clsx(styles.wrapper, {
              [styles.cart]: pageType === 'cart'
            })}
          >
            <p>
              Edycja zamówienia z obecnym terminem dostawy jest możliwa do{' '}
              <b>
                {parseDateToDDMMYYYY(startOrder.editableUntil)}{' '}
                {getTimeFromDate(startOrder.editableUntil)}
              </b>
              . Pamiętaj aby ją zatwierdzić przed upływem tego terminu.
            </p>
            {pageType !== 'payment' && (
              <EditSaleOrderReminderButtons
                handleCancelEditOrder={handleCancelEditOrder}
                handleSubmitEditOrder={handleSubmitEditOrder}
                direction={buttonsDirection}
              />
            )}
          </div>
        )}
      </>
    ) : (
      <>
        <div className={styles.wrapper}>
          <p>
            Wystąpił błąd podczas pobierania danych edycji zamówienia. Anuluj
            tryb edcji i spróbuj ponownie.
          </p>
          {pageType !== 'payment' && (
            <EditSaleOrderReminderButtons
              handleCancelEditOrder={handleCancelEditOrder}
              direction={buttonsDirection}
            />
          )}
        </div>
      </>
    )
  ) : null
}

export default EditSaleOrderReminder
